export default __webpack_public_path__ + "static/media/DLink.4c2f207c.svg";